import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Section } from '../Section';
import { CtaBlock } from '../CtaBlock';
export function Guarantee() {
  return <Section tone="panel" data-id="element-148" data-mp="20j8r63133o61">
      <div className="mx-auto max-w-2xl rounded-2xl border border-teal/35 bg-teal/[0.06] p-5 text-center sm:p-8" data-id="element-149" data-mp="24molgspolcfk">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-teal/20" data-id="element-150" data-mp="29eyl50gllqv1">
          <ShieldCheckIcon className="h-7 w-7 text-teal-bright" aria-hidden="true" data-id="element-151" data-mp="2ebygohftnb7w" />
        </span>
        <h2 className="mt-4 font-display text-[26px] font-bold uppercase leading-[1.08] text-white sm:text-4xl" data-id="element-152" data-mp="2ja9s2wlrlts8">
          Try it for 7 days — risk free
        </h2>
        <p className="mt-3 text-[15px] leading-relaxed text-white/70 sm:text-base" data-id="element-153" data-mp="2sbrfl01i4xqy">
          Your purchase is protected by our 7-Day Satisfaction Guarantee. Go
          through the Master Manuals, use the system and decide if it’s right for
          you. If you feel that Master Welding System™ isn’t what you expected,
          simply contact us within 7 days and we’ll refund your purchase.
        </p>
        <p className="mt-4 text-[13px] font-extrabold uppercase tracking-wide text-teal-bright sm:text-sm" data-id="element-154" data-mp="3nty9mv48jgf0">
          No risk. No long forms. No complicated process.
        </p>
        <p className="mt-2 text-[15px] font-semibold text-white" data-id="element-155" data-mp="3dxbqcark4xf3">
          You don’t have to take the risk. We do.
        </p>
      </div>

      <CtaBlock className="mt-10" headline="Try it with zero risk for 7 days" data-id="element-156" data-mp="fe52v7zphjb5" />
    </Section>;
}